module.exports = __webpack_public_path__ + "static/media/login.898fc6ab.png";